// Paper Bag Product Functionality
console.log('Product Paper Bag JS loaded');
console.log('Body classes:', document.body.className);

class PaperBagProduct {
    constructor() {
    console.log('PaperBagProduct initialized');
    
    // State
    this.selectedSize = 'Uber'; // Only size currently available
    this.selectedPrintType = 'Simple'; // Only print type currently available
    this.selectedQuantity = 250;
    this.isRushed = false;
    
    // Constants
      this.UNITS_PER_CARTON = 1000;
    this.RUSH_MULTIPLIER = 1.3; // 30% surcharge
    
    // Sizes that support Full Colour Print (none for paper bags currently)
    this.fullColourSizes = [];
    
    // Pricing data for display in the table (shows breakdown to users)
    // Currently only Uber size and Simple print are available
    this.pricingData = {
      "Uber_Simple": [
        { qty: 250, price: 2.20 },
        { qty: 500, price: 1.50 },
        { qty: 1000, price: 1.15 },
        { qty: 2000, price: 0.85 },
        { qty: 3000, price: 0.80 },
        { qty: 4000, price: 0.77 },
        { qty: 5000, price: 0.75 }
      ]
    };
      
          // Variant mapping for quantity-based pricing
    // PLACEHOLDER VARIANT IDs - Replace with actual Shopify variant IDs
    // Currently only Uber size and Simple print are available
    this.variantMapping = {
      "Uber_Simple": {
        "250": "50809805373722",
        "500": "50809805406490",
        "1000": "50809805439258",
        "2000": "50809805472026",
        "3000": "50809805504794",
        "4000": "50809805537562",
        "5000": "50809805570330"
      }
    };


      
      this.init();
    }

    init() {
    this.setupSizeSelector();
    this.setupPrintTypeSelector();
    this.setupFullColourIncompatibilityPopup();
    this.setupTurnaroundSelector();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.setupShippingCalculator();
    this.setupDynamicDescription();
    this.setupTooltips();
    this.updatePrintTypeAvailability();
    this.autoSelectMOQQuantity(); // Auto-select MOQ quantity for initial size/print combination
    this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }

  // Auto-select MOQ quantity based on size and print type
  autoSelectMOQQuantity() {
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    
    if (!variants) return;
    
    // Get the minimum quantity available for this configuration (which is the MOQ)
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    const moqQuantity = quantities[0]; // First (smallest) quantity is the MOQ
    
    console.log(`Auto-selecting MOQ for ${pricingKey}: ${moqQuantity}`);
    
    // Update the selected quantity
    this.selectedQuantity = moqQuantity;
  }
  
  setupSizeSelector() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up size selector, found buttons:', sizeButtons.length);
    
    // Initialize correct button state on page load
    this.initializeSizeButtonState();
    
    sizeButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        // Prevent clicking on disabled buttons
        if (btn.classList.contains('disabled') || btn.classList.contains('out-of-stock')) {
          console.log('Size button is disabled:', btn.dataset.size);
          return;
        }
        
        console.log('Size button clicked:', btn.dataset.size);
        
        // Update selection
        sizeButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedSize = btn.dataset.size;
        console.log('Size selected:', this.selectedSize);
        
        this.updatePrintTypeAvailability();
        this.autoSelectMOQQuantity(); // Auto-select MOQ quantity when size changes
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  initializeSizeButtonState() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Initializing size button state...');
    
    // Force correct state immediately
    this.forceCorrectButtonState();
    
    // Also force it again after a delay to override any other scripts
    setTimeout(() => {
      this.forceCorrectButtonState();
    }, 100);
    
    setTimeout(() => {
      this.forceCorrectButtonState();
    }, 500);
  }

  forceCorrectButtonState() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('Forcing correct button state...');
    
    // Force correct size button states
    sizeButtons.forEach(btn => {
      const size = btn.dataset.size;
      
      if (size === 'Small' || size === 'Medium' || size === 'Large') {
        // Force these to be disabled and not selected
        btn.classList.remove('selected');
        btn.classList.add('disabled', 'out-of-stock');
        console.log(`Forced ${size} to disabled state`);
      } else if (size === 'Uber') {
        // Force Uber to be selected and not disabled
        btn.classList.remove('disabled', 'out-of-stock');
        btn.classList.add('selected');
        this.selectedSize = 'Uber';
        console.log('Forced Uber to selected state');
      }
    });

    // Force correct print type button states
    printButtons.forEach(btn => {
      const printType = btn.dataset.printType;
      
      if (printType === 'FullColour') {
        // Force Full Colour to be disabled and not selected
        btn.classList.remove('selected');
        btn.classList.add('disabled', 'out-of-stock');
        console.log('Forced Full Colour to disabled state');
      } else if (printType === 'Simple') {
        // Force Simple to be selected and not disabled
        btn.classList.remove('disabled', 'out-of-stock');
        btn.classList.add('selected');
        this.selectedPrintType = 'Simple';
        console.log('Forced Simple to selected state');
      }
    });
  }
  
  setupPrintTypeSelector() {
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('[PrintType Debug] Setting up print type selector, found buttons:', printButtons.length);
    
    printButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Prevent clicking on disabled buttons
        if (btn.classList.contains('disabled') || btn.classList.contains('out-of-stock')) {
          console.log('Print type button is disabled:', btn.dataset.printType);
          return;
        }
        
        // Update selection
        printButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedPrintType = btn.dataset.printType;
        console.log('Print type selected:', this.selectedPrintType);
        
        // Auto-select MOQ quantity based on new print type
        this.autoSelectMOQQuantity();
        
        this.updatePricingTable();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  setupFullColourIncompatibilityPopup() {
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    
    if (fullColourBtn) {
      // Show popup on click when disabled - exactly like coasters
      fullColourBtn.addEventListener('click', () => {
        if (fullColourBtn.classList.contains('disabled')) {
          this.showFullColourIncompatibilityPopup();
        }
      });

      // Also show on hover when disabled
      fullColourBtn.addEventListener('mouseenter', () => {
        if (fullColourBtn.classList.contains('disabled')) {
          this.showFullColourIncompatibilityPopup();
        }
      });

      // Hide popup when mouse leaves
      fullColourBtn.addEventListener('mouseleave', () => {
        this.hideFullColourIncompatibilityPopup();
      });
    }
  }

  showFullColourIncompatibilityPopup() {
    // Remove any existing popups
    this.hideFullColourIncompatibilityPopup();
    
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    if (!fullColourBtn) return;
    
    // Get button position
    const rect = fullColourBtn.getBoundingClientRect();
    
    // Create popup element - exactly like coasters
    const popup = document.createElement('div');
    popup.className = 'print-type-incompatible-popup show';
    popup.id = 'full-colour-incompatible-popup-new';
    popup.textContent = 'Full colour print is not available for paper bags';
    
    // Style the popup - exactly like coasters
    Object.assign(popup.style, {
      position: 'fixed',
      background: '#dc2626',
      color: 'white',
      padding: '0.75rem 1rem',
      borderRadius: '8px',
      fontSize: '0.85rem',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      zIndex: '99999',
      boxShadow: '0 8px 16px rgba(220, 38, 38, 0.3)',
      opacity: '1',
      visibility: 'visible'
    });
    
    // Add to document first to measure width
    document.body.appendChild(popup);
    
    // Get popup width for proper centering
    const popupRect = popup.getBoundingClientRect();
    
    // Position above the button, properly centered
    popup.style.left = rect.left + (rect.width / 2) - (popupRect.width / 2) + 'px';
    popup.style.top = rect.top - popupRect.height - 8 + 'px';
    
    // Auto-hide after 3 seconds if user hovers away
    setTimeout(() => {
      this.hideFullColourIncompatibilityPopup();
    }, 3000);
  }
  
  hideFullColourIncompatibilityPopup() {
    const existingPopup = document.getElementById('full-colour-incompatible-popup-new');
    if (existingPopup) {
      existingPopup.remove();
    }
  }
  

  
  setupTurnaroundSelector() {
    const turnaroundPills = document.querySelectorAll('.turnaround-pill');
    turnaroundPills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Update selection
        turnaroundPills.forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');
        
        this.isRushed = pill.dataset.turnaround === 'rushed';
        console.log('Turnaround selected:', pill.dataset.turnaround, 'isRushed:', this.isRushed);
        
      this.updatePricingTable();
        this.updateShippingCalculator();
      });
    });
  }

  setupShippingCalculator() {
    // Initialize the shipping calculator on page load
    this.updateShippingCalculator();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      console.log('Shipping calculator elements not found');
      return;
    }

    // Determine production days and shipping times based on turnaround selection
    const productionDays = this.isRushed ? 5 : 10;
    const minDeliveryDays = this.isRushed ? 6 : 11;
    const maxDeliveryDays = this.isRushed ? 8 : 13;

    // Calculate dates
    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    const doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    const minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);

    // Format dates
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    // Update delivery range with selected production time
    const productionTimeText = this.isRushed ? 'Rushed (5 business days)' : 'Standard (10 business days)';
    
    if (minDeliveryDays === maxDeliveryDays) {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(doorstepDate)}`;
    } else {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    // Update timeline dates
    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  setupDynamicDescription() {
    // Initialize with default size (4oz)
    this.updateDynamicDescription();
    
    // Setup accordion dropdown functionality (only one open at a time)
    this.setupAccordionBehavior('.dynamic-description'); // Desktop version
    this.setupAccordionBehavior('.dynamic-description-mobile'); // Mobile version
    
    // Auto-open the first tab (Description) on page load
    this.openDescriptionTab();
  }

  openDescriptionTab() {
    // Open description tab on desktop
    const desktopDescriptionTitle = document.querySelector('.dynamic-description .dropdown-title[data-target="description-content"]');
    const desktopDescriptionContent = document.getElementById('description-content');
    
    if (desktopDescriptionTitle && desktopDescriptionContent) {
      desktopDescriptionTitle.classList.add('active');
      desktopDescriptionContent.classList.add('active');
    }
    
    // Open description tab on mobile
    const mobileDescriptionTitle = document.querySelector('.dynamic-description-mobile .dropdown-title[data-target="description-content-mobile"]');
    const mobileDescriptionContent = document.getElementById('description-content-mobile');
    
    if (mobileDescriptionTitle && mobileDescriptionContent) {
      mobileDescriptionTitle.classList.add('active');
      mobileDescriptionContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    console.log('Setting up accordion behavior for:', containerSelector);
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.log('Container not found:', containerSelector);
      return;
    }
    
    const dropdownTitles = container.querySelectorAll('.dropdown-title');
    console.log('Found dropdown titles:', dropdownTitles.length);
    
    dropdownTitles.forEach((title, index) => {
      console.log(`Styling dropdown title ${index}:`, title.textContent);
      // Force bold styling directly on the element
      title.style.fontWeight = '700';
      title.style.fontWeight = 'bold';
      title.style.setProperty('font-weight', '700', 'important');
      console.log('Applied styles to:', title.textContent, 'font-weight:', title.style.fontWeight);
      
      title.addEventListener('click', (e) => {
        const targetId = title.getAttribute('data-target');
        const content = document.getElementById(targetId);
        
        if (content) {
          const isCurrentlyActive = title.classList.contains('active');
          
          // Close all dropdowns in this container first
          dropdownTitles.forEach(otherTitle => {
            const otherTargetId = otherTitle.getAttribute('data-target');
            const otherContent = document.getElementById(otherTargetId);
            
            if (otherContent) {
              otherTitle.classList.remove('active');
              otherContent.classList.remove('active');
            }
          });
          
          // If this wasn't active, open it
          if (!isCurrentlyActive) {
            title.classList.add('active');
            content.classList.add('active');
          }
        }
      });
    });
  }

  updateDynamicDescription() {
    const descriptionData = this.getDescriptionData();
    
    // Update desktop version
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');
    
    // Update mobile version
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');
    
    if (descriptionData) {
      // Update desktop
      if (descriptionContent) {
        descriptionContent.innerHTML = descriptionData.description;
      }
      if (specificationContent) {
        specificationContent.innerHTML = descriptionData.specification;
      }
      if (dielinesContent) {
        dielinesContent.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) {
        howItWorksContent.innerHTML = descriptionData.howItWorks;
      }
      
      // Update mobile (same content)
      if (descriptionContentMobile) {
        descriptionContentMobile.innerHTML = descriptionData.description;
      }
      if (specificationContentMobile) {
        specificationContentMobile.innerHTML = descriptionData.specification;
      }
      if (dielinesContentMobile) {
        dielinesContentMobile.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) {
        howItWorksContentMobile.innerHTML = descriptionData.howItWorks;
      }
    }
  }

  getDescriptionData() {
    const sizeDescriptions = {
      "Small": {
        description: `
          <p>Our Small Paper Bags (180mm x 220mm + 80mm gusset) are perfect for small retail items, gifts, and promotional materials. Lightweight yet durable with twisted paper handles, they're ideal for boutique stores, events, and branded merchandise distribution.</p>
          <p><strong>Available in Simple print:</strong></p>
          <p>• <strong>Simple:</strong> clean logo and text prints on kraft or white background (MOQ 250 units)</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Size:</span> <span class="spec-value">180mm x 220mm + 80mm gusset</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">120gsm FSC-certified kraft paperboard</span></li>
            <li><span class="spec-label">Handle:</span> <span class="spec-value">Twisted paper handles</span></li>
            <li><span class="spec-label">Handle Drop:</span> <span class="spec-value">100mm</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple print</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Weight Capacity:</span> <span class="spec-value">2-3kg</span></li>
            <li><span class="spec-label">Packaging:</span> <span class="spec-value">Flat packed, some assembly required</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline template:</p>
          <a href="/pages/contact-us" class="download-btn">👉 Get in touch</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size, print type, and finish, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom bags go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "Medium": {
        description: `
          <p>Our Medium Paper Bags (240mm x 320mm + 100mm gusset) offer the perfect balance of size and convenience. Ideal for medium retail purchases, gift items, and promotional materials with reinforced construction and strong handles for reliable carrying.</p>
          <p><strong>Available in Simple print:</strong></p>
          <p>• <strong>Simple:</strong> professional logos and branding on premium backgrounds (MOQ 250 units)</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Size:</span> <span class="spec-value">240mm x 320mm + 100mm gusset</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">130gsm FSC-certified kraft paperboard</span></li>
            <li><span class="spec-label">Handle:</span> <span class="spec-value">Twisted paper handles</span></li>
            <li><span class="spec-label">Handle Drop:</span> <span class="spec-value">130mm</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple print</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Weight Capacity:</span> <span class="spec-value">4-5kg</span></li>
            <li><span class="spec-label">Packaging:</span> <span class="spec-value">Flat packed, some assembly required</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the template to ensure perfect print placement:</p>
          <a href="/pages/contact-us" class="download-btn">👉 Get in touch</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size, print type, and finish, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom bags go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "Large": {
        description: `
          <p>Our Large Paper Bags (320mm x 420mm + 120mm gusset) are designed for bigger purchases and maximum brand impact. Perfect for retail stores, shopping centers, and large promotional campaigns with reinforced construction for substantial weight carrying.</p>
          <p><strong>Available in Simple print:</strong></p>
          <p>• <strong>Simple:</strong> bold logos and branding on premium kraft or white backgrounds (MOQ 250 units)</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Size:</span> <span class="spec-value">320mm x 420mm + 120mm gusset</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">140gsm FSC-certified kraft paperboard</span></li>
            <li><span class="spec-label">Handle:</span> <span class="spec-value">Reinforced twisted paper handles</span></li>
            <li><span class="spec-label">Handle Drop:</span> <span class="spec-value">150mm</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple print</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Weight Capacity:</span> <span class="spec-value">6-8kg</span></li>
            <li><span class="spec-label">Packaging:</span> <span class="spec-value">Flat packed, some assembly required</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the template for perfect artwork placement:</p>
          <a href="/pages/contact-us" class="download-btn">👉 Get in touch</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size, print type, and finish, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom bags go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "Uber": {
        description: `
          <p>Our Uber Paper Bags (305mm x 305mm + 150mm gusset) are the ultimate in size and brand presence. Perfect for large purchases, bulk items, and maximum marketing impact with premium construction, extra-strong handles, and substantial weight capacity.</p>
          <p><strong>Available in Simple print:</strong></p>
          <p>• <strong>Simple:</strong> striking logos and messaging on premium backgrounds (MOQ 250 units)</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Size:</span> <span class="spec-value">305mm x 305mm + 150mm gusset</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">150gsm FSC-certified kraft paperboard</span></li>
            <li><span class="spec-label">Handle:</span> <span class="spec-value">Premium reinforced twisted paper handles</span></li>
            <li><span class="spec-label">Handle Drop:</span> <span class="spec-value">180mm</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple print</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Weight Capacity:</span> <span class="spec-value">10-12kg</span></li>
            <li><span class="spec-label">Packaging:</span> <span class="spec-value">Flat packed, some assembly required</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the template for perfect large-format artwork placement:</p>
          <a href="/pages/contact-us" class="download-btn">👉 Get in touch</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with large format templates or artwork setup? We're here to help you make the biggest impact.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size, print type, and finish, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom bags go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      }
    };
    
    return sizeDescriptions[this.selectedSize] || sizeDescriptions["Small"];
  }
  
  setupTooltips() {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon[data-tooltip]');
    
    tooltipIcons.forEach(icon => {
      let tooltip = null;
      
      const showTooltip = (e) => {
        // Remove any existing tooltips
        document.querySelectorAll('.tooltip-popup').forEach(t => t.remove());
        
        const tooltipText = icon.getAttribute('data-tooltip');
        if (!tooltipText) return;
        
        // Create tooltip element
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.innerHTML = tooltipText;
        
        // Style the tooltip
        Object.assign(tooltip.style, {
          position: 'absolute',
          background: '#000000',
          color: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.4',
          maxWidth: '300px',
          width: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          zIndex: '9999',
          opacity: '0',
          visibility: 'hidden',
          transition: 'all 0.2s ease',
          pointerEvents: 'none'
        });
        
        // Add to DOM - append to the icon's parent container for better positioning
        const container = icon.closest('.form__label') || icon.parentElement;
        container.style.position = 'relative';
        container.appendChild(tooltip);
        
        // Position tooltip relative to icon
        const iconRect = icon.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        // Get tooltip dimensions after adding to DOM
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.visibility = 'hidden';
        
        // Calculate position relative to container
        const iconLeft = iconRect.left - containerRect.left;
        const iconTop = iconRect.top - containerRect.top;
        
        // Position above the icon, centered horizontally
        let left = iconLeft + (iconRect.width / 2) - (tooltipRect.width / 2);
        let top = iconTop - tooltipRect.height - 8;
        
        // Keep tooltip within viewport
        const viewportWidth = window.innerWidth;
        const tooltipLeftInViewport = containerRect.left + left;
        const tooltipRightInViewport = tooltipLeftInViewport + tooltipRect.width;
        
        // Adjust horizontal position if going off screen
        if (tooltipLeftInViewport < 10) {
          left = 10 - containerRect.left;
        } else if (tooltipRightInViewport > viewportWidth - 10) {
          left = (viewportWidth - 10 - containerRect.left) - tooltipRect.width;
        }
        
        // If no room above, show below
        if (containerRect.top + top < 10) {
          top = iconTop + iconRect.height + 8;
        }
        
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
        
        // Show tooltip
        requestAnimationFrame(() => {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
      };
      
      const hideTooltip = () => {
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
          setTimeout(() => {
            if (tooltip && tooltip.parentNode) {
              tooltip.parentNode.removeChild(tooltip);
            }
            tooltip = null;
          }, 200);
        }
      };
      
      // Add event listeners
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
    
         // Clean up tooltips on page interactions
     document.addEventListener('scroll', () => {
       document.querySelectorAll('.tooltip-popup').forEach(t => {
         if (t.parentNode) t.parentNode.removeChild(t);
       });
     });
     
     document.addEventListener('click', (e) => {
       if (!e.target.closest('.tooltip-icon')) {
         document.querySelectorAll('.tooltip-popup').forEach(t => {
           if (t.parentNode) t.parentNode.removeChild(t);
         });
       }
          });
  }
  
  setupFormSubmission() {
    const customButton = document.getElementById('custom-add-to-cart-btn');
    if (customButton) {
      customButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }
  
  setupFileUpload() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    if (!fileInput) {
      console.log('File upload input not found');
      return;
    }

    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileInfo = document.querySelector('div[id^="fileInfo-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');
    const removeButton = document.querySelector('button[id^="removeFile-"]');

    // Click handler for upload area
    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      // Drag and drop handlers
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
        
        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0]);
        }
      });
    }

    // File selection handler
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file);
    });

    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection();
      });
    }
  }

  handleFileSelection(file) {
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');

    if (!file) {
      this.clearFileSelection();
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      this.clearFileSelection();
      return;
    }

    // Hide upload area and show preview
    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    // Update file info
    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    // Show image preview for image files
    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      // Hide image preview for non-image files
      if (imagePreview) imagePreview.style.display = 'none';
    }

    console.log('File selected:', file.name, file.type, file.size);
  }

  clearFileSelection() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');

    // Clear the file input
    if (fileInput) fileInput.value = '';

    // Show upload area and hide preview
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';

    console.log('File selection cleared');
  }
  
  updatePrintTypeAvailability() {
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    const unavailableIndicator = fullColourBtn?.querySelector('.unavailable-indicator');
    
    if (fullColourBtn && unavailableIndicator) {
      const isAvailable = this.fullColourSizes.includes(this.selectedSize);
      
      if (isAvailable) {
        fullColourBtn.classList.remove('disabled');
        unavailableIndicator.style.display = 'none';
      } else {
        fullColourBtn.classList.add('disabled');
        unavailableIndicator.style.display = 'inline';
        
        // Switch to Simple Print if Full Colour was selected
        if (this.selectedPrintType === 'FullColour') {
          const simplePrintBtn = document.getElementById('simple-print-btn');
          if (simplePrintBtn) {
            simplePrintBtn.click();
    }
        }
      }
    }
  }
  
  getPricingKey() {
    const printType = this.selectedPrintType === 'FullColour' ? 'FullColour' : 'Simple';
    return `${this.selectedSize}_${printType}`;
  }



  async loadProductData() {
    if (this.productData) return this.productData;
    
    try {
      // First try to get from existing ProductJSON script
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (productScript) {
        this.productData = JSON.parse(productScript.textContent);
        console.log('Loaded product data from script:', this.productData.handle);
        return this.productData;
      }
      
      // Fallback: fetch from API using product handle from URL
      const pathParts = window.location.pathname.split('/');
      const handle = pathParts[pathParts.indexOf('products') + 1];
      
      if (handle) {
        const response = await fetch(`/products/${handle}.js`);
        this.productData = await response.json();
        console.log('Loaded product data from API:', this.productData.handle);
        return this.productData;
      }
      
      throw new Error('Could not determine product handle');
    } catch (error) {
      console.error('Failed to load product data:', error);
      return null;
    }
  }

  async updatePricingTable() {
      const tbody = document.getElementById('quantity-grid-body');
      if (!tbody) return;

    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    
    console.log('Updating pricing for:', pricingKey, variants);
    
    if (!variants) {
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }
    
    // Load product data for price lookup (but don't require it)
    await this.loadProductData();
    
      tbody.innerHTML = '';

    // Get available quantities for this configuration
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    
    for (let i = 0; i < quantities.length; i++) {
      const qty = quantities[i];
      const variantId = variants[qty.toString()];
      // Try to find variant in product data
      let variant = null;
      let variantPrice = 0;
      let unitPrice = 0;
      if (this.productData) {
        variant = this.productData.variants.find(v => v.id == variantId);
      }
      if (variant) {
        // Use live Shopify pricing
        if (typeof variant.price === 'string') {
          variantPrice = parseFloat(variant.price);
        } else {
          // Assume cents, convert to dollars
          variantPrice = variant.price / 100;
        }
        unitPrice = variantPrice / qty;
        console.log(`[Live Pricing] Qty: ${qty}, VariantID: ${variantId}, Price: ${variantPrice}, Unit: ${unitPrice}`);
      } else {
        // Fallback: use hardcoded pricing as backup
        const fallbackData = this.pricingData[pricingKey];
        const fallbackPrice = fallbackData?.find(p => p.qty === qty);
        if (fallbackPrice) {
          unitPrice = fallbackPrice.price;
          variantPrice = unitPrice * qty;
        } else {
          unitPrice = 2.20; // Default fallback
          variantPrice = unitPrice * qty;
        }
        console.warn(`[Fallback Pricing] Qty: ${qty}, VariantID: ${variantId}, Price: ${variantPrice}, Unit: ${unitPrice}`);
      }
      
      const row = document.createElement('tr');
      row.classList.add('quantity-row');
      row.dataset.quantity = qty;
      
      // Make entire row clickable
      row.addEventListener('click', () => {
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Radio button
      const radioCell = document.createElement('td');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'quantity_selection';
      radio.value = qty;
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Pre-select first option or maintain current selection
      if ((i === 0 && this.selectedQuantity === null) || qty === this.selectedQuantity) {
        radio.checked = true;
        this.selectedQuantity = qty;
        this.currentUnitPrice = unitPrice;
        row.classList.add('selected');
      }
      
      radioCell.appendChild(radio);
      row.appendChild(radioCell);
        
      // Quantity
      const qtyCell = document.createElement('td');
      qtyCell.textContent = qty.toLocaleString();
      row.appendChild(qtyCell);

      // Unit Price with membership pricing
      const unitPriceCell = document.createElement('td');
      
      // Check for membership pricing
      const customerTags = document.body.dataset.customerTags || '';
      const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
      let memberTier = null;
      let discountPercent = 0;
      
      if (window.MembershipPricing) {
        memberTier = window.MembershipPricing.getCustomerTier();
        discountPercent = window.MembershipPricing.getDiscountPercent();
      } else {
        // Fallback to legacy logic for bronze/silver/gold/trade
        if (tags.includes('trade')) {
          memberTier = 'trade';
          discountPercent = 20;
        } else if (tags.includes('gold')) {
          memberTier = 'gold';
          discountPercent = 15;
        } else if (tags.includes('silver')) {
          memberTier = 'silver';
          discountPercent = 10;
        } else if (tags.includes('bronze')) {
          memberTier = 'bronze';
          discountPercent = 5;
        }
      }
      
      if (memberTier && discountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - discountPercent / 100);
        console.log(`[Membership Debug] Unit Price - Original: $${unitPrice.toFixed(2)}, Discounted: $${discountedUnitPrice.toFixed(2)}, Tier: ${memberTier}`);
        
        unitPriceCell.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
          <span class="membership-badge membership-${memberTier}">${memberTier === 'trade' ? '💎' : memberTier === 'gold' ? '🥇' : memberTier === 'silver' ? '🥈' : '🥉'}</span>
        `;
      } else {
        unitPriceCell.textContent = `$${unitPrice.toFixed(2)}`;
      }
      unitPriceCell.style.textAlign = 'center';
      row.appendChild(unitPriceCell);

      // Total Price with membership discount
      const totalCell = document.createElement('td');
      
      if (memberTier && discountPercent > 0) {
        const discountedTotal = variantPrice * (1 - discountPercent / 100);
        totalCell.innerHTML = `
          <span class="original-price">$${variantPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
        `;
      } else {
        totalCell.textContent = `$${variantPrice.toFixed(2)}`;
      }
      row.appendChild(totalCell);

        tbody.appendChild(row);
    }

    this.updateRowSelection();
    this.updateSelectedQuantityDisplay();
    }

  updateRowSelection() {
    // Remove selection from all rows
    document.querySelectorAll('.quantity-row').forEach(row => {
      row.classList.remove('selected');
    });
    
    // Add selection to current row
    if (this.selectedQuantity) {
      const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`);
      if (selectedRow) {
        selectedRow.classList.add('selected');
      }
    }
  }
  
  updateSelectedQuantityDisplay() {
    // Update any selected quantity display elements
    const selectedQtyElements = document.querySelectorAll('.selected-quantity-display');
    selectedQtyElements.forEach(el => {
      el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : '';
    });
    
    // Update order summary
    this.updateOrderSummary();
  }
  
  updateOrderSummary() {
    if (!this.selectedQuantity) return;
    
    // Get current pricing for display calculations
    const pricingKey = this.getPricingKey();
    const priceBreaks = this.pricingData[pricingKey];
    const priceBreak = priceBreaks?.find(p => p.qty === this.selectedQuantity);
    
    if (!priceBreak) return;
    
    // Get membership info for all calculations
    const customerTags = document.body.dataset.customerTags || '';
    const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
    // Use centralized membership pricing system
    let memberTier = null;
    let memberDiscountPercent = 0;
    
    if (window.MembershipPricing) {
      memberTier = window.MembershipPricing.getCustomerTier();
      memberDiscountPercent = window.MembershipPricing.getDiscountPercent();
    } else {
      // Fallback to legacy logic for bronze/silver/gold/trade
      if (tags.includes('trade')) {
        memberTier = 'trade';
        memberDiscountPercent = 20;
      } else if (tags.includes('gold')) {
        memberTier = 'gold';
        memberDiscountPercent = 15;
      } else if (tags.includes('silver')) {
        memberTier = 'silver';
        memberDiscountPercent = 10;
      } else if (tags.includes('bronze')) {
        memberTier = 'bronze';
        memberDiscountPercent = 5;
      }
    }
    
    let unitPrice = priceBreak.price;
    let rushFee = 0;
    // Calculate bag total and apply member discount
    let bagTotal = this.selectedQuantity * unitPrice;
    
    // Apply member discount to bag total
    if (memberDiscountPercent > 0) {
      bagTotal = bagTotal * (1 - memberDiscountPercent / 100);
      console.log(`[Bag Debug] Member discount applied to bag total: ${memberDiscountPercent}% off`);
    }
    
    let totalPrice = bagTotal;

    // Hide finish/lid row since we don't use it
    const lidRow = document.getElementById('summary-lid-row');
    if (lidRow) {
      lidRow.style.display = 'none';
    }

    // Add rush surcharge (for display purposes)
    if (this.isRushed) {
      // Only apply rush to bags, not finish - use base bag total for rush calculation
      const baseBagTotal = this.selectedQuantity * priceBreak.price;
      if (memberDiscountPercent > 0) {
        const discountedBase = baseBagTotal * (1 - memberDiscountPercent / 100);
        rushFee = discountedBase * (this.RUSH_MULTIPLIER - 1);
        const originalRushFee = Math.round(baseBagTotal * (this.RUSH_MULTIPLIER - 1));
        document.getElementById('summary-rush-row').style.display = '';
        document.getElementById('summary-rush-fee').innerHTML = `
          <span class="original-price">$${originalRushFee.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${rushFee.toFixed(2)}</span>
        `;
      } else {
        rushFee = Math.round(baseBagTotal * (this.RUSH_MULTIPLIER - 1));
        document.getElementById('summary-rush-row').style.display = '';
        document.getElementById('summary-rush-fee').textContent = `$${rushFee.toFixed(2)}`;
      }
      totalPrice += rushFee;
    } else {
      document.getElementById('summary-rush-row').style.display = 'none';
      document.getElementById('summary-rush-fee').textContent = '$0.00';
      }

    // Update summary elements
    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');
    
    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();
    
    if (summaryUnitPrice) {
      if (memberDiscountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - memberDiscountPercent / 100);
        summaryUnitPrice.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
        `;
      } else {
        summaryUnitPrice.textContent = `$${unitPrice.toFixed(2)}`;
      }
    }
    
    if (summaryTotal) {
      if (memberDiscountPercent > 0) {
        const originalBagTotal = this.selectedQuantity * priceBreak.price;
        const originalRush = this.isRushed ? Math.round(originalBagTotal * (this.RUSH_MULTIPLIER - 1)) : 0;
        const originalSubtotal = originalBagTotal + originalRush;
        const totalSavings = originalSubtotal - totalPrice;
        summaryTotal.innerHTML = `
          <span class="original-price">$${originalSubtotal.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${totalPrice.toFixed(2)}</span>
        `;
        const discountRow = document.getElementById('summary-discount-row');
        const discountLabel = document.getElementById('summary-discount-label');
        const discountAmountEl = document.getElementById('summary-discount-amount');
        if (discountRow && discountLabel && discountAmountEl) {
          discountRow.style.display = 'flex';
          discountLabel.textContent = `${memberTier.toUpperCase()} Member Discount (${memberDiscountPercent}%):`;
          discountAmountEl.textContent = `-$${totalSavings.toFixed(2)}`;
          discountAmountEl.style.color = '#28a745';
          discountAmountEl.style.fontWeight = '600';
        }
      } else {
        summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;
        const discountRow = document.getElementById('summary-discount-row');
        if (discountRow) discountRow.style.display = 'none';
      }
    }
  }

  async addToCart() {
    const button = document.getElementById('custom-add-to-cart-btn');
    if (!button) return;

    // Validate that a design file is uploaded
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    // File upload is now optional, so skip this check

    // Show loading state
    button.classList.add('loading');
    button.disabled = true;

    try {
      // Get the correct variant ID based on size, print type, and quantity
      const pricingKey = this.getPricingKey();
      const quantityKey = String(this.selectedQuantity);
      const variantId = this.variantMapping[pricingKey]?.[quantityKey];
      
      console.log('[AddToCart Debug] Selected variant ID:', variantId);
      
      if (!variantId) {
        throw new Error(`No variant found for ${pricingKey} - ${quantityKey} units.`);
      }

      // Create FormData to handle file upload
      const formData = new FormData();

      // Shared group id so the bag and its rush fee stay linked in the cart
      // (cart grouping keys off _epk_group). Without this the rush fee renders as
      // a separate, unlinked card.
      const epkGroup = 'epkorder-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1000000).toString(36);

      // Add the main bag variant
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', '1');
      formData.append('items[0][properties][Size]', this.selectedSize);
      formData.append('items[0][properties][Print Type]', this.selectedPrintType);
      formData.append('items[0][properties][Quantity]', this.selectedQuantity);
      formData.append('items[0][properties][Price/Unit]', `$${this.calculateUnitPrice().toFixed(2)}`);
      formData.append('items[0][properties][_epk_group]', epkGroup);
      
      // Add the uploaded file
      if (fileInput.files[0]) {
        formData.append('items[0][properties][Design File]', fileInput.files[0]);
      }

      let itemIndex = 1; // Start next items at index 1

      // Add rush fee as separate product if rushed is selected
      if (this.isRushed) {
        const variantTotalPrice = this.calculateVariantTotalPrice();
        const rushFeeAmount = variantTotalPrice * (this.RUSH_MULTIPLIER - 1);
        const rushFeeQuantity = Math.round(rushFeeAmount);
        
        formData.append(`items[${itemIndex}][id]`, '50675778126106');
        formData.append(`items[${itemIndex}][quantity]`, rushFeeQuantity);
        formData.append(`items[${itemIndex}][properties][Base Order Total]`, `$${variantTotalPrice.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][Rush Fee (5 business days) +30%]`, `$${rushFeeAmount.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][_epk_group]`, epkGroup);
      }

      // Submit to cart using FormData (supports file uploads)
      const response = await fetch('/cart/add', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add to cart: ${response.status} - ${errorText}`);
      }

      // Success
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Set flag for success state after page refresh
      localStorage.setItem('cartAddSuccess', 'true');
      // Reload page to update cart UI (since we're using form submission)
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error('Cart error:', error);
      this.showMessage(`Error adding to cart: ${error.message}`, 'error');
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }
  
  // Helper method to calculate unit price
  calculateUnitPrice() {
    const pricingKey = this.getPricingKey();
    const priceBreaks = this.pricingData[pricingKey];
    const priceBreak = priceBreaks?.find(p => p.qty === this.selectedQuantity);
    return priceBreak ? priceBreak.price : 0;
  }

  // Helper method to calculate variant total price
  calculateVariantTotalPrice() {
    // Calculate total price dynamically based on current pricing data
    const unitPrice = this.calculateUnitPrice();
    const totalPrice = unitPrice * this.selectedQuantity;
    
    console.log(`[VariantTotalPrice] Unit: $${unitPrice}, Qty: ${this.selectedQuantity}, Total: $${totalPrice}`);
    
    return totalPrice;
  }
  
  showMessage(text, type) {
    console.log('showMessage called:', text, type);
    
    // Remove existing messages
    const existingMessages = document.querySelectorAll('.cup-message, .bag-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create new toast message
    const message = document.createElement('div');
    message.className = `bag-message bag-${type}-message bag-toast-message`;
    message.textContent = text;
    
    // Position the toast near the Add to cart button
    const addToCartButton = document.querySelector('#custom-add-to-cart-btn') || 
                           document.querySelector('.custom-add-to-cart-button') ||
                           document.querySelector('.product-form-bag__cart-submit') || 
                           document.querySelector('#product-form-bag button[type="submit"]') ||
                           document.querySelector('button[name="add"]');
    
    console.log('Found button:', addToCartButton);
    
    if (addToCartButton) {
      const buttonRect = addToCartButton.getBoundingClientRect();
      console.log('Button rect:', buttonRect);
      
      // Position the toast near the button
      message.style.position = 'fixed';
      message.style.top = `${buttonRect.top + (buttonRect.height / 2) - 30}px`;
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      console.log('Toast appended to body');
      
      // Trigger slide-in animation
      setTimeout(() => {
        message.classList.add('show');
        console.log('Toast show class added');
      }, 10);
      
      // Auto-remove after 3 seconds
      setTimeout(() => {
        message.classList.add('hide');
      setTimeout(() => {
        message.remove();
          console.log('Toast removed');
        }, 300); // Allow fade-out animation to complete
      }, 3000);
    } else {
      console.warn('Add to cart button not found, falling back to simple display');
      // Fallback: just append to body with default positioning
      message.style.position = 'fixed';
      message.style.top = '20px';
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      
      setTimeout(() => {
        message.classList.add('show');
      }, 10);
      
      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
        }, 300);
      }, 3000);
    }
  }
  
  // Helper function to convert decimal to fraction
  decimalToFraction(decimal) {
    if (decimal >= 1) {
      return Math.floor(decimal).toString();
    }
    
    // Common fractions for carton sizes
    const fractions = {
      0.25: '1/4',
      0.5: '1/2',
      0.75: '3/4'
    };
    
    return fractions[decimal] || decimal.toString();
    }

  updateMediaGalleryForSelectedVariant() {
    // Get the correct variant ID based on current selections
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const variantId = this.variantMapping[pricingKey]?.[quantityKey];
    
    if (!variantId) {
      console.log('No variant ID found for:', pricingKey, quantityKey);
      return;
    }

    console.log('Updating for variant ID:', variantId);
    
    // Update variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      console.log('Updated variant input to:', variantId);
    });

    // Update URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);
    
    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);
    
    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }
      
      const productData = JSON.parse(productScript.textContent);
      const variant = productData.variants?.find(v => v.id == variantId);
      
      if (!variant || !variant.featured_media?.id) {
        console.log('No variant or featured media found for:', variantId);
        return;
      }
      
      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);
      
      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }
      
      // Get the section ID from the media gallery
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${variant.featured_media.id}`;
      
      console.log('Looking for media with ID:', targetMediaId);
      
      // Find the thumbnail with the matching data-target
      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          console.log('Found thumbnail button, clicking it');
          button.click();
          return;
        }
      }
      
      // Fallback: directly call setActiveMedia if thumbnail click didn't work
      console.log('Thumbnail not found, using direct media switching');
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
      } else {
        // Manual fallback
        this.manualMediaSwitch(targetMediaId);
      }
      
    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }
  
  manualMediaSwitch(targetMediaId) {
    console.log('Manual media switch to:', targetMediaId);
    
    // Remove active from all media items
    const allMediaItems = document.querySelectorAll('.product__media-item');
    allMediaItems.forEach(item => {
      item.classList.remove('is-active');
    });
    
    // Add active to target media item
    const targetMediaItem = document.querySelector(`[data-media-id="${targetMediaId}"]`);
    if (targetMediaItem) {
      targetMediaItem.classList.add('is-active');
      console.log('Manually activated media item:', targetMediaId);
      
      // Also update thumbnails
      const allThumbnails = document.querySelectorAll('[data-target] button');
      allThumbnails.forEach(btn => {
        btn.removeAttribute('aria-current');
        btn.parentElement.classList.remove('is-active');
      });
      
      const targetThumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (targetThumbnail) {
        const button = targetThumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', 'true');
          targetThumbnail.classList.add('is-active');
        }
      }
    } else {
      console.log('Target media item not found:', targetMediaId);
    }
  }

  checkCartAddSuccess() {
    const successFlag = localStorage.getItem('cartAddSuccess');
    if (successFlag === 'true') {
      localStorage.removeItem('cartAddSuccess');
      this.showMessage('Added to cart successfully!', 'success');
    }
  }

  preventAutoScroll() {
    // More comprehensive scroll prevention following ChatGPT recommendation
    
    // 1. Override scrollIntoView temporarily during variant changes
    const originalScrollIntoView = Element.prototype.scrollIntoView;
    let preventScrolling = false;
    
    const blockScrollIntoView = () => {
      preventScrolling = true;
      Element.prototype.scrollIntoView = () => {}; // Block all scrollIntoView calls
      
      // Re-enable after a short delay
      setTimeout(() => {
        Element.prototype.scrollIntoView = originalScrollIntoView;
        preventScrolling = false;
      }, 500);
    };
    
    // 2. Prevent scroll on variant option changes (universal fix)
    document.querySelectorAll('[name="options"] select, [name="options"] input').forEach(el => {
      el.addEventListener('change', (e) => {
        blockScrollIntoView();
        
        // Prevent URL-based auto-scroll
        const url = new URL(window.location);
        url.searchParams.set(el.name, el.value);
        history.replaceState({}, '', url);
      });
    });
    
    // 3. Prevent scroll on our custom buttons
    const buttons = document.querySelectorAll('.size-btn, .print-type-btn, .lids-pill, .turnaround-pill');
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        blockScrollIntoView();
        // Don't prevent default here as it would break functionality
      });
    });
    
    // 4. Intercept variant form changes
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      variantSelects.addEventListener('change', () => {
        blockScrollIntoView();
      });
    }
  }
}

// Smooth scroll to shipping calculator function
function scrollToShippingCalculator(event) {
  event.preventDefault();
  
  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Smooth scroll to ETA calculator section function
function scrollToEtaCalculator(event) {
  event.preventDefault();
  
  const etaCalculatorSection = document.getElementById('eta-calculator-section');
  if (etaCalculatorSection) {
    etaCalculatorSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Legacy function for backwards compatibility
function scrollToDesignUpload(event) {
  event.preventDefault();
  
  const designUploadSection = document.getElementById('design-upload-section');
  if (designUploadSection) {
    designUploadSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Test function for toast notification
function testToast() {
  if (window.paperBagProduct) {
    window.paperBagProduct.showMessage('Test toast message!', 'success');
  } else {
    console.error('PaperBagProduct not found');
  }
}

// Force bold function for dropdown titles
function forceBoldTitles() {
  console.log('Running forceBoldTitles...');
  
  // Find all dropdown titles
  const allTitles = document.querySelectorAll('.dropdown-title, .description-title');
  console.log('Found titles:', allTitles.length);
  
  allTitles.forEach((title, index) => {
    console.log(`Making title bold: ${title.textContent.trim()}`);
    
    // Use regular bold font-weight without text-shadow
    title.style.setProperty('font-weight', 'bold', 'important');
    title.classList.add('force-bold');
  });
  
  // NOW MAKE VARIANT SELECTOR TITLES BLACK
  const variantLabels = document.querySelectorAll('.form__label');
  console.log('Found variant labels:', variantLabels.length);
  
  variantLabels.forEach((label, index) => {
    console.log(`Making variant label black: ${label.textContent.trim()}`);
    label.style.setProperty('color', '#000000', 'important');
    label.style.setProperty('font-weight', 'bold', 'important');
  });
  
  // MAKE MAIN PRODUCT TITLE BLACK
  const mainProductTitle = document.querySelector('.product__title h1');
  if (mainProductTitle) {
    console.log(`Making main product title black: ${mainProductTitle.textContent.trim()}`);
    mainProductTitle.style.setProperty('color', '#000000', 'important');
  }
  
  // MAKE PRODUCT TAGLINE BLACK
  const productTagline = document.querySelector('.product-tagline');
  if (productTagline) {
    console.log(`Making product tagline black: ${productTagline.textContent.trim()}`);
    productTagline.style.setProperty('color', '#000000', 'important');
  }
  
  // Add CSS rule if it doesn't exist
  if (!document.querySelector('#force-bold-style')) {
    const style = document.createElement('style');
    style.id = 'force-bold-style';
    style.textContent = `
      .force-bold, .dropdown-title, .description-title {
        font-weight: 700 !important;
      }
      .form__label {
        color: #000000 !important;
        font-weight: bold !important;
      }
      .product__title h1 {
        color: #000000 !important;
      }
      .product-tagline {
        color: #000000 !important;
      }
    `;
    document.head.appendChild(style);
    console.log('Added force-bold CSS rule');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const pricingTable = document.getElementById('quantity-grid-body');
  const sizeButtons = document.querySelectorAll('.size-btn');
  
  if (pricingTable && sizeButtons.length > 0) {
    window.paperBagProduct = new PaperBagProduct();
  }
});